/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

document.addEventListener("DOMContentLoaded", function() {
  //The first argument are the elements to which the plugin shall be initialized
  //The second argument has to be at least a empty object or a object with your desired options
  // OverlayScrollbars(document.querySelectorAll('.accordion__panel__scroll'), {
  //   className:'os-theme-dark',
  //   scrollbars: {
  //     dragScrolling: true,
  //     autoHide: 'never',
  //   },
  //  });
});
